// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

const createColumnApi = (state, action) => action.columnApi;

export default (state = {}, action) => {

    const actionTypes = {
        [actions.CREATE_AG_GRID_API]: createColumnApi
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/shared/reducers/column-api.js